export const DEFAULT_PROGRESS_RING_DIMENSIONS = {
  width: 48,
  height: 48,
  cx: 24,
  cy: 24,
  r: 22,
  strokeWidth: 4,
};

export const DEFAULT_GRADIENT_COLORS: GradientColors = {
  startColor: {
    hex: '#4E06F2',
    p3: 'color(display-p3 0.3059 0.0235 0.9490)',
  },
  endColor: {
    hex: '#4951EF',
    p3: 'color(display-p3 0.2863 0.3176 0.9373)',
  },
};

export interface GradientColors {
  startColor: {
    hex: string;
    p3?: string;
  };
  endColor: {
    hex: string;
    p3?: string;
  };
}

export interface ProgressRingProps {
  progressPercent: number;
  isOpen: boolean;
  currentGiftCount?: number;
  children?: React.ReactNode;
  dimensions?: typeof DEFAULT_PROGRESS_RING_DIMENSIONS;
  showCheck?: boolean;
  useGradient?: boolean;
  progressColor?: string;
  gradientColors?: GradientColors;
  countTextColor?: string;
  typographyVariant?: 'hed1' | 'hed2' | 'hed3';
}
export interface Dimensions {
  width: number;
  height: number;
  cx: number;
  cy: number;
  r: number;
  strokeWidth: number;
}
